import { mainSplitApi } from "../../mainSplitApi";
import PROPERTY_DRAFT_TAG_TYPES from "./property-draft.tags";
import STATS_TAG_TYPES from "../stats/stats.tags";
import { PropertyDraftEndpoints } from "../../endpoints/property-draft.endpoints";
import { DraftListValuesQRTK } from "./values/draft-list.values";
import { DraftDetailValuesQRTK } from "./values/draft-detail.values";
import { DraftDeleteValuesQRTK } from "./values/draft-delete.values";
import { DraftDeleteAllValuesQRTK } from "./values/draft-delete-all.values";
import { DraftUpdateValuesQRTK } from "./values/draft-update.values";
import { IDraftListResponse } from "./responses/draft-list.response";
import { IDraftDetailResponse } from "./responses/draft-detail.response";
import { IDraftDeleteResponse } from "./responses/draft-delete.response";
import { IDraftDeleteAllResponse } from "./responses/draft-delete-all.response";
import { IDraftUpdateResponse } from "./responses/draft-update.response";
import { IDraftCreateResponse } from "./responses/draft-create.response";
import { DraftCreateValuesQRTK } from "./values/draft-create.values";
import { IDraftUploadImageResponse } from "./responses/draft-upload-image.response";
import { IDraftUploadDocumentResponse } from "./responses/draft-upload-document.response";
import { DraftUploadImageValuesQRTK } from "./values/draft-upload-image.values";
import { DraftUploadDocumentValuesQRTK } from "./values/draft-upload-document.values";
import { IDraftDeleteImageResponse } from "./responses/draft-delete-image.response";
import { IDraftDeleteDocumentResponse } from "./responses/draft-delete-document.response";
import { DraftDeleteImageValuesQRTK } from "./values/draft-delete-image.values";
import { DraftDeleteDocumentValuesQRTK } from "./values/draft-delete-document.values";
import HGetFormData from "@rf-helper/create-form-data.helper";

export const PropertyDraftQueryServices = mainSplitApi.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    draftList: query<IDraftListResponse, DraftListValuesQRTK>({
      query: values => ({
        url: PropertyDraftEndpoints.DraftList,
        method: "GET",
        params: values.query
      }),
      transformResponse: (response: IDraftListResponse) => {
        return response;
      },
      providesTags: [PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_LIST]
    }),

    draftDetail: query<IDraftDetailResponse, DraftDetailValuesQRTK>({
      query: values => ({
        url: PropertyDraftEndpoints.DraftDetail(values.params.id),
        method: "GET",
        params: values.query
      }),
      transformResponse: (response: IDraftDetailResponse) => response,
      providesTags: [PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_DETAIL]
    }),

    draftDelete: mutation<IDraftDeleteResponse, DraftDeleteValuesQRTK>({
      query: values => ({
        url: PropertyDraftEndpoints.DraftDelete(values.params.id),
        method: "DELETE",
        body: values.body
      }),
      transformResponse: (response: IDraftDeleteResponse) => response,
      invalidatesTags: [
        PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_LIST
        // PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_DETAIL,
        // STATS_TAG_TYPES.STATS_GET // Invalidar stats cuando se elimina un borrador
      ]
    }),

    draftDeleteAll: mutation<IDraftDeleteAllResponse, DraftDeleteAllValuesQRTK>({
      query: values => ({
        url: PropertyDraftEndpoints.DraftDeleteAll,
        method: "DELETE"
      }),
      transformResponse: (response: IDraftDeleteAllResponse) => response,
      invalidatesTags: [
        PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_LIST,
        // PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_DETAIL,
        STATS_TAG_TYPES.STATS_GET // Invalidar stats cuando se eliminan todos los borradores
      ]
    }),

    draftUpdate: mutation<IDraftUpdateResponse, DraftUpdateValuesQRTK>({
      query: values => ({
        url: PropertyDraftEndpoints.DraftUpdate(values.params.id),
        method: "POST",
        body: values.body
      }),
      transformResponse: (response: IDraftUpdateResponse) => response,
      invalidatesTags: [
        // PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_LIST,
        // PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_DETAIL,
        // STATS_TAG_TYPES.STATS_GET // Invalidar stats cuando se actualiza un borrador
      ]
    }),
    CreateDraft: mutation<IDraftCreateResponse, DraftCreateValuesQRTK>({
      query: values => ({
        url: PropertyDraftEndpoints.DraftCreate,
        method: "POST",
        body: values.body
      }),
      transformResponse: (response: IDraftCreateResponse) => response,
      invalidatesTags: [
        PROPERTY_DRAFT_TAG_TYPES.PROPERTY_DRAFT_LIST,
        STATS_TAG_TYPES.STATS_GET // Invalidar stats cuando se crea un borrador
      ]
    }),
    draftUploadImage: mutation<
      IDraftUploadImageResponse,
      DraftUploadImageValuesQRTK
    >({
      query: values => ({
        url: PropertyDraftEndpoints.DraftUploadImage(values.params.draft),
        method: "POST",
        body: HGetFormData(values.body)
      }),
      transformResponse: (response: IDraftUploadImageResponse) => response
    }),
    draftUploadDocument: mutation<
      IDraftUploadDocumentResponse,
      DraftUploadDocumentValuesQRTK
    >({
      query: values => ({
        url: PropertyDraftEndpoints.DraftUploadDocument(values.params.draft),
        method: "POST",
        body: HGetFormData(values.body)
      })
    }),
    draftDeleteImage: mutation<
      IDraftDeleteImageResponse,
      DraftDeleteImageValuesQRTK
    >({
      query: values => ({
        url: PropertyDraftEndpoints.DraftDeleteImage(
          values.params.draft,
          values.params.image
        ),
        method: "DELETE"
      })
    }),
    draftDeleteDocument: mutation<
      IDraftDeleteDocumentResponse,
      DraftDeleteDocumentValuesQRTK
    >({
      query: values => ({
        url: PropertyDraftEndpoints.DraftDeleteDocument(
          values.params.draft,
          values.params.document
        ),
        method: "DELETE"
      })
    })
  })
});

export const {
  useDraftListQuery,
  useLazyDraftListQuery,
  useDraftDetailQuery,
  useLazyDraftDetailQuery,
  useDraftDeleteMutation,
  useDraftDeleteAllMutation,
  useDraftUpdateMutation,
  useCreateDraftMutation,
  useDraftUploadImageMutation,
  useDraftUploadDocumentMutation,
  useDraftDeleteImageMutation,
  useDraftDeleteDocumentMutation
} = PropertyDraftQueryServices;
